import { useState, useEffect } from 'react';
import { api } from "../../services/POST";

function Success() {
  const params = new URLSearchParams(window.location.search);
  const shopname = params.get('shopname');
  const [domain, setDomain] = useState(''); // <-- Add this line to store the domain

  useEffect(() => { 
    async function fetchDomain() {
      try {
        const result = await api("/getActualShopDomain")
        setDomain(result.domain);
      } catch (error) {
        console.error("Error setting domain:", error);
      }
    }

    fetchDomain(); 
  }, [shopname]);

  return (
    <div className="flex justify-center items-center h-screen bg-white">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">Probléma történt a vásárlás során!</h1>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="16" 
          height="16" 
          fill="currentColor" 
          className="h-24 w-24 text-red-700 mx-auto mb-4"
          viewBox="0 0 16 16"
        > 
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/> 
          <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/> 
        </svg>

        <button className="bg-black text-white py-2 px-4 rounded-md" onClick={() => {window.parent.location.href = 'https://'+domain+'/admin/app/176'}}>Vissza a főoldalra</button>
      </div>
    </div>
  );
}

export default Success;
  
